import { Badge, Tooltip } from '@mantine/core'
import { IconEyeOff } from '@tabler/icons-react'

interface RestrictedFieldIndicatorProps {
  tooltip?: string
  /** Texto curto no badge. Default: "Não exibido nesta visão" */
  label?: string
}

/**
 * Indica que um campo NÃO É EXIBIDO na visualização atual do dashboard
 * (por design da visão, não por bloqueio de permissão).
 *
 * NOTA: este componente é informativo/visual. Não bloqueia acesso a dados —
 * usuários com permissão podem ver o conteúdo trocando de perfil/dashboard.
 */
export function RestrictedFieldIndicator({
  tooltip = 'Esta informação não é exibida nesta visão do dashboard. Troque de perfil para ver outras visões.',
  label = 'Não exibido nesta visão',
}: RestrictedFieldIndicatorProps) {
  return (
    <Tooltip label={tooltip} position="top" multiline w={280}>
      <Badge
        variant="light"
        color="gray"
        size="sm"
        leftSection={<IconEyeOff size={12} style={{ marginTop: 2 }} />}
      >
        {label}
      </Badge>
    </Tooltip>
  )
}
